import React, { useEffect, useRef } from 'react'
import { Canvas, extend } from '@react-three/fiber'
import { Html, OrbitControls, ScrollControls } from '@react-three/drei'
import { useSpring } from '@react-spring/core'
import { a } from '@react-spring/web'
import { DragControls } from 'three/examples/jsm/controls/DragControls'
import Scene from './Scene'
import AppDeck from './Card'
import Control from './Control'
import * as THREE from 'three'
import ControlProject from './ControlProject'
import { useStore } from '../store'
extend({ DragControls })
export default function Project() {
  const { setProject, project } = useStore()
  return (
    <a.main className='bql-project' >
      <Canvas className="canvas" dpr={[1, 2]}>
        <Scene setBg={null} />
        <Control />
        <Html
          as='div'
          transform
        // prepend 
        // sprite 
        // distanceFactor={10}
        // scale={new THREE.Vector3(0.5,0.5,0.5)}
        >
        <AppDeck />


        </Html>
      </Canvas>
      <ControlProject />
    </a.main>
  )
}
